import React, { Component } from "react";
import { FormErrors, reduxForm } from "redux-form";
import {ff, form, HorizontalLoader} from "@mc/mc-legacy";
import { Button } from "reactstrap";
import { toastr } from "react-redux-toastr";
import SpravaUctuApi from "../../api/gen/core/SpravaUctuApi";
import * as TwoFactorType from "../../api/gen/core/TwoFactorType";
import {withLang} from "../../i18n/withLang";
import {i18n} from "../../i18n/i18n";
/**
 * Formulář potvrzení pomocí SMS.
 */
type FormData = { smsCode: string };
class SmsConfirm extends Component<any, { twoFactorTypeResponse: any; userCodeSubmitErrorMessage: any }> {
  static validate = (data: FormData, props) => {
    const errors: FormErrors<FormData> = {};

    if (!data.smsCode) {
      errors.smsCode = i18n(props.lang, "Validation_fieldRequired");
    }

    return errors;
  };

  constructor(props) {
    super(props);
    this.state = {
      twoFactorTypeResponse: props.twoFactorTypeResponse,
      userCodeSubmitErrorMessage: null,
    };
  }

  handleNewSms = () => {
    const { twoFactorTypeResponse } = this.state;
    const { untouch, change } = this.props;
    SpravaUctuApi.twoFactorRepeatSms({ repeatRequestCode: twoFactorTypeResponse.repeatRequestCode }).then((resp) => {
      if (resp) {
        toastr.success("", {
          component: (
            <div>
              {i18n(this.props.lang, "ProfilePage_smsConfirm_Sent")}{" "}
              <span className="text-nowrap">{resp.kontakt}</span>
            </div>
          ),
        });
        this.setState({
          twoFactorTypeResponse: resp,
          userCodeSubmitErrorMessage: null,
        });
        change("smsCode", "");
        untouch("smsCode");
      }
    });
  };
  customHandleSubmit = (event) => {
    const { onSuccess, onSubmit, handleSubmit } = this.props;
    handleSubmit((data) => {
      return onSubmit(data).then((resp) => {
        switch (resp.twoFactorType) {
          case TwoFactorType.SMS:
            // chyba ověření, máme stále SMS
            this.setState({
              twoFactorTypeResponse: resp,
              userCodeSubmitErrorMessage: i18n(this.props.lang, "ProfilePage_smsConfirmCodeNotValid"),
            });
            break;

          default:
            // jiná metoda nebo ok končíme
            onSuccess(resp);
        }
      });
    })(event);
  };

  render() {
    const { error, submitting } = this.props;
    const { userCodeSubmitErrorMessage, twoFactorTypeResponse } = this.state;
    let disabled = submitting || twoFactorTypeResponse.remainingAttempts === 0;
    return (
      <form.Form className={"form"} horiznotal onSubmit={this.customHandleSubmit}>
        <form.FormBody>
          <h4>{i18n(this.props.lang, "ProfilePage_smsConfirm")}</h4>
          <p>{i18n(this.props.lang, "ProfilePage_smsConfirmEnterCode", twoFactorTypeResponse.kontakt)}</p>
          {userCodeSubmitErrorMessage && twoFactorTypeResponse.remainingAttempts > 0 && (
            <p>{i18n(this.props.lang, "ProfilePage_smsConfirmEnterCodeRemainingAttempts", twoFactorTypeResponse.remainingAttempts)}</p>
          )}
          {userCodeSubmitErrorMessage && twoFactorTypeResponse.remainingAttempts === 0 && (
            <p>{i18n(this.props.lang, "ProfilePage_smsConfirmRemainingAttempts_NO")}</p>
          )}
          {error && <form.ValidationErrors error={error} />}
          {userCodeSubmitErrorMessage && <form.ValidationErrors error={userCodeSubmitErrorMessage} />}
          <ff.String
            autoComplete={"off"}
            label={false}
            placeholder={i18n(this.props.lang, "ProfilePage_smsConfirmCodePlaceholder")}
            name={"smsCode"}
            disabled={disabled}
            required
          />
        </form.FormBody>
        <form.FormActions submitting={submitting} submitButton={false}>
            <Button disabled={disabled} className={"btn btn-primary py-15"}>
                {i18n(this.props.lang, "ProfilePage_smsConfirmVerify")}
                {submitting && <HorizontalLoader/>}
            </Button>
            <Button color="link" className="ml-2 pr-0 pl-0" onClick={this.handleNewSms}>
                {i18n(this.props.lang, "ProfilePage_smsConfirm_SendAgain")}
            </Button>
        </form.FormActions>
      </form.Form>
    );
  }
}

const SmsConfirmForm = reduxForm<FormData, any>({
  form: "smsConfirm",
  validate: SmsConfirm.validate,
})(SmsConfirm);
export default withLang(SmsConfirmForm);
